export interface GalleryItem {
  id: number;
  title: string;
  category: string;
  duration: string;
  price: string;
  imageUrl: string;
}

export const galleryItems: GalleryItem[] = [
  {
    id: 1,
    title: "ロゼパールフレンチ",
    category: "ジェルネイル",
    duration: "90分",
    price: "¥9,800",
    imageUrl: "https://public.readdy.ai/ai/img_res/f3f330406f30b71d070264ab93522838.jpg"
  },
  {
    id: 2,
    title: "オーロラグラデーション",
    category: "アートネイル",
    duration: "120分",
    price: "¥13,200",
    imageUrl: "https://readdy.ai/api/search-image?query=stunning%20aurora%20ombre%20gradient%20nail%20art%20on%20beautiful%20hands%2C%20iridescent%20holographic%20pastel%20colors%20shifting%20from%20soft%20pink%20to%20lavender%20to%20mint%2C%20gel%20nails%20with%20glitter%20powder%20finish%2C%20clean%20beige%20background%2C%20luxury%20nail%20salon%20professional%20photography%2C%20Japanese%20kawaii%20nail%20art%20style%2C%20sparkly%20high%20end%20finish&width=400&height=400&seq=gal2&orientation=squarish"
  },
  {
    id: 3,
    title: "フローラルエンボス",
    category: "3Dアート",
    duration: "150分",
    price: "¥16,500",
    imageUrl: "https://readdy.ai/api/search-image?query=3D%20embossed%20floral%20nail%20art%20on%20elegant%20hands%2C%20white%20and%20blush%20pink%20raised%20flower%20petals%20sculpted%20on%20nude%20beige%20gel%20nails%2C%20intricate%20Japanese%20nail%20art%20design%2C%20professional%20close%20up%20beauty%20photography%2C%20soft%20cream%20white%20background%2C%20luxury%20salon%20craftsmanship%2C%20delicate%20feminine%20aesthetic&width=400&height=400&seq=gal3&orientation=squarish"
  },
  {
    id: 4,
    title: "ミルクティーマット",
    category: "シンプル",
    duration: "80分",
    price: "¥8,800",
    imageUrl: "https://readdy.ai/api/search-image?query=minimalist%20milk%20tea%20matte%20nail%20art%20on%20feminine%20hands%2C%20warm%20beige%20and%20caramel%20latte%20tones%20matte%20finish%20gel%20nails%2C%20subtle%20thin%20gold%20foil%20accent%20line%2C%20professional%20nail%20photography%2C%20clean%20off%20white%20marble%20background%2C%20Japanese%20minimalist%20nail%20style%2C%20elegant%20simple%20beauty%20photography&width=400&height=400&seq=gal4&orientation=squarish"
  },
  {
    id: 5,
    title: "チェリーブロッサム",
    category: "季節限定",
    duration: "120分",
    price: "¥12,100",
    imageUrl: "https://readdy.ai/api/search-image?query=cherry%20blossom%20sakura%20nail%20art%20on%20beautiful%20Japanese%20hands%2C%20delicate%20hand%20painted%20pink%20sakura%20flowers%20on%20soft%20white%20gel%20nail%20base%2C%20falling%20petals%20design%2C%20professional%20beauty%20close%20up%20photography%2C%20light%20pastel%20pink%20background%2C%20spring%20seasonal%20nail%20art%2C%20elegant%20feminine%20Japanese%20aesthetic&width=400&height=400&seq=gal5&orientation=squarish"
  },
  {
    id: 6,
    title: "ゴールドマーブル",
    category: "ラグジュアリー",
    duration: "100分",
    price: "¥11,000",
    imageUrl: "https://readdy.ai/api/search-image?query=luxury%20gold%20marble%20nail%20art%20on%20elegant%20feminine%20hands%2C%20white%20marble%20texture%20with%20gold%20veining%20on%20gel%20nails%2C%2024k%20gold%20leaf%20accent%20details%2C%20professional%20nail%20salon%20photography%2C%20pristine%20white%20and%20cream%20background%2C%20high%20end%20Japanese%20nail%20design%2C%20glamorous%20and%20sophisticated%20beauty%20photography&width=400&height=400&seq=gal6&orientation=squarish"
  },
  {
    id: 7,
    title: "テラコッタラテ",
    category: "トレンド",
    duration: "90分",
    price: "¥9,900",
    imageUrl: "https://readdy.ai/api/search-image?query=trendy%20terracotta%20latte%20nail%20art%20on%20feminine%20hands%2C%20warm%20earthy%20tones%20burnt%20sienna%20and%20dusty%20rose%20gel%20nails%2C%20clay%20like%20matte%20finish%20with%20subtle%20cream%20accents%2C%20professional%20beauty%20photography%2C%20warm%20beige%20sandy%20background%2C%20autumn%20inspired%20Japanese%20nail%20design%2C%20minimalist%20elegant%20aesthetic&width=400&height=400&seq=gal7&orientation=squarish"
  },
  {
    id: 8,
    title: "クリスタルクリア",
    category: "ガラスネイル",
    duration: "110分",
    price: "¥12,800",
    imageUrl: "https://readdy.ai/api/search-image?query=crystal%20glass%20nail%20art%20on%20beautiful%20hands%2C%20transparent%20glass%20like%20gel%20nails%20with%20crushed%20crystal%20and%20aurora%20powder%20inside%2C%20see%20through%20jelly%20nails%20with%20sparkling%20gems%2C%20professional%20close%20up%20photography%2C%20clean%20white%20background%2C%20Korean%20Japanese%20nail%20trend%2C%20luxury%20beauty%20photography&width=400&height=400&seq=gal8&orientation=squarish"
  },
  {
    id: 9,
    title: "バイオレットフォグ",
    category: "アートネイル",
    duration: "120分",
    price: "¥13,800",
    imageUrl: "https://readdy.ai/api/search-image?query=soft%20dusty%20mauve%20pink%20gel%20nails%20on%20feminine%20hands%20with%20smoky%20rose%20gradient%20and%20delicate%20silver%20foil%20dot%20accents%2C%20pastel%20purple%20toned%20nail%20art%20with%20misty%20ethereal%20finish%2C%20bright%20clean%20white%20studio%20background%2C%20professional%20Japanese%20nail%20salon%20beauty%20photography%2C%20close%20up%20well%20lit%20shot&width=400&height=400&seq=violet_fog_2026a&orientation=squarish"
  }
];

export const galleryCategories = ["すべて", "ジェルネイル", "アートネイル", "3Dアート", "シンプル", "季節限定", "ラグジュアリー", "トレンド", "ガラスネイル"];
